import { Injectable } from '@angular/core';
import { ToastController, LoadingController, AlertController } from 'ionic-angular';

@Injectable()
export class Componentes {

  default

  toast: any;
  loading: any;
  alerta: any;

  constructor(
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController
  ) {

  }

  apresentaToast(message) {
    this.toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    this.toast.present();
  }

  apresentaAlerta(message, title = 'Campina Grill') {
    this.alerta = this.alertCtrl.create({
      title: title,
      subTitle: message,
      buttons: ['OK']
    });
    this.alerta.present();
  }

  apresentaLoading(message) {
    this.loading = this.loadingCtrl.create({
      content: message
    });
    this.loading.present();
  }

  removeLoading() {
    this.loading.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/providers/componentes.ts